export default "__VITE_ASSET__30e081fb__"